<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <FullDom />
    </div>
</template>
<script>
import FullDom from '../src/components/detail/full-dom.vue'
export default {
    components: {
        FullDom
    },
    methods: {
        getCurrentPageUrl() {
            let currentUrl = window.location.href
            wx.miniProgram.postMessage({ data: { currentUrl: encodeURIComponent(currentUrl) } })
        }
    },
    watch: {
        // 监听路由对象中的变化
        $route: {
            handler: function(to, from) {
                // 当路由发生变化时会调用这个函数
                // to 和 from 分别代表到达的路由和离开的路由
                // this.getCurrentPageUrl()
                // 在这里可以根据路由变化执行相应的逻辑
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        }
    }
}
</script>

<style lang="scss">
/* CSS Reset Begin */
input {
    box-sizing: border-box;
    outline: none;
}
body {
    //  iphone 刘海兼容问题
    padding-top: env(safe-area-inset-top);
    padding-right: env(safe-area-inset-right);
    //padding-bottom: 20px;  /* 兼容不支持 env( ) 的设备  */
    padding-bottom: calc(env(safe-area-inset-bottom)); /* 在 iphone x + 中本句才会生效 */
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    padding-left: env(safe-area-inset-left);
}
body,
ul {
    margin: 0;
}
a {
    color: inherit;
    text-decoration: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
ul {
    list-style: none;
}
/* CSS Reset End*/
::-webkit-scrollbar {
    display: none;
}
html,
body {
    //   height: 100%;
    //width: 100%;
}
#app {
    //   height: 100%;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}
.clearfix:after {
    content: '.';
    display: block;
    height: 0;
    clear: both;
    visibility: hidden;
}
.swiper-scrollbar-drag {
    background: #d21034 !important;
}
@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
    .bottom-container,
    .bottom-box {
        padding-bottom: calc(-0.4rem + constant(safe-area-inset-bottom));
        padding-bottom: calc(-0.4rem + env(safe-area-inset-bottom));
    }
    .btn-box {
        padding-bottom: calc(-0.8rem + constant(safe-area-inset-bottom));
        padding-bottom: calc(-0.8rem + env(safe-area-inset-bottom));
    }
    .filter-box {
        padding-bottom: 2.4rem;
    }
}

@media only screen and (max-width: 600px) and (orientation: portrait),
    screen and (max-width: 960px) and (orientation: landscape) {
    /* 针对iPhone 5-6/7-8，iPad 在横屏和竖屏时的样式 */
    .sku-size-ios {
        line-height: 0.35rem !important;
    }
}

@media only screen and(device-width:428px) and (device-height: 926px) and(-webkit-min-device-pixel-ratio: 3) {
    // iphone 13 daiyanzheng
    // .sku-size-ios {
    //     background: red !important;
    // }
}

// @media only screen and (min-device-width: 320px) and (max-device-width: 568px) and (-webkit-min-device-pixel-ratio: 2) and (device-type: mobile) {
//     /* iPhone 5-6 */
//     .sku-size {
//         line-height: 0.4rem !important;
//         margin-top: 0.9rem !important;
//         // background: red;
//     }
// }
// @media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) and (device-type: mobile) {
//     /* iPhone 6-7 */
//     .sku-size {
//         line-height: 0.4rem !important;
//         margin-top: 0.9rem !important;
//         // background: red;
//     }
// }

// @media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 3) and (device-type: mobile) {
//     /* iPhone 6-8 */
//     .sku-size {
//         line-height: 0.4rem !important;
//         margin-top: 0.9rem !important;
//         // background: red;
//     }
// }

html,
body {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
}
/* 隐藏滚动条，但允许滚动 */
html::-webkit-scrollbar {
    width: 0;
    height: 0;
}
</style>
